
import { TranslationSet } from '../types';

export const benefits: TranslationSet = {
  'benefits.unlimitedEntries': {
    en: 'Unlimited Entries',
    ja: '無制限のエントリー',
    es: 'Entradas ilimitadas',
    zh: '无限条目',
    fa: 'ورودی‌های نامحدود'
  },
  'benefits.unlimitedDescription': {
    en: 'Create as many diary entries as you like without any restrictions.',
    ja: '制限なしで好きなだけ日記エントリーを作成できます。',
    es: 'Crea tantas entradas de diario como quieras sin restricciones.',
    zh: '无任何限制地创建任意数量的日记条目。',
    fa: 'بدون هیچ محدودیتی هر تعداد ورودی روزانه که می‌خواهید ایجاد کنید.'
  },
  'benefits.growthStatistics': {
    en: 'Growth Statistics',
    ja: '成長統計',
    es: 'Estadísticas de crecimiento',
    zh: '成长统计',
    fa: 'آمار رشد'
  },
  'benefits.growthDescription': {
    en: 'Track your baby\'s growth with detailed statistics and charts.',
    ja: '詳細な統計とチャートで赤ちゃんの成長を追跡します。',
    es: 'Realiza un seguimiento del crecimiento de tu bebé con estadísticas y gráficos detallados.',
    zh: '通过详细的统计和图表跟踪宝宝的成长。',
    fa: 'رشد کودک خود را با آمار و نمودارهای دقیق پیگیری کنید.'
  },
  'benefits.photoGallery': {
    en: 'Photo Gallery',
    ja: 'フォトギャラリー',
    es: 'Galería de fotos',
    zh: '照片库',
    fa: 'گالری عکس'
  },
  'benefits.photoDescription': {
    en: 'Upload and organize all your baby photos in a beautiful gallery.',
    ja: '美しいギャラリーですべての赤ちゃんの写真をアップロードして整理します。',
    es: 'Sube y organiza todas las fotos de tu bebé en una hermosa galería.',
    zh: '在美丽的画廊中上传和整理所有宝宝照片。',
    fa: 'تمام عکس‌های کودک خود را در یک گالری زیبا آپلود و سازماندهی کنید.'
  },
  'benefits.basicEntry': {
    en: 'Basic Entry',
    ja: '基本エントリー',
    es: 'Entrada básica',
    zh: '基础条目',
    fa: 'ورودی پایه'
  },
  'benefits.basicDescription': {
    en: 'Quickly jot down notes and memories.',
    ja: 'メモや思い出を素早く記録します。',
    es: 'Apunta rápidamente notas y recuerdos.',
    zh: '快速记下笔记和回忆。',
    fa: 'سریعاً یادداشت‌ها و خاطرات را ثبت کنید.'
  },
  'benefits.advancedEntry': {
    en: 'Advanced Entry',
    ja: '高度なエントリー',
    es: 'Entrada avanzada',
    zh: '高级条目',
    fa: 'ورودی پیشرفته'
  },
  'benefits.advancedDescription': {
    en: 'Add detailed information, including milestones, activities, and more.',
    ja: 'マイルストーン、活動などの詳細情報を追加します。',
    es: 'Añade información detallada, incluyendo hitos, actividades y más.',
    zh: '添加详细信息，包括里程碑、活动等。',
    fa: 'اطلاعات دقیق، شامل مراحل رشد، فعالیت‌ها و موارد دیگر را اضافه کنید.'
  },
  'benefits.prioritySupport': {
    en: 'Priority Support',
    ja: '優先サポート',
    es: 'Soporte prioritario',
    zh: '优先支持',
    fa: 'پشتیبانی ویژه'
  },
  'benefits.supportDescription': {
    en: 'Get faster responses and dedicated support from our team.',
    ja: '迅速な回答と私たちのチームからの専属サポートを受けられます。',
    es: 'Obtén respuestas más rápidas y soporte dedicado de nuestro equipo.',
    zh: '获得更快的响应和我们团队的专属支持。',
    fa: 'پاسخ‌های سریع‌تر و پشتیبانی اختصاصی از تیم ما دریافت کنید.'
  },
  'benefits.premiumFeature': {
    en: 'Premium Feature',
    ja: 'プレミアム機能',
    es: 'Función Premium',
    zh: '高级功能',
    fa: 'ویژگی حساب ویژه'
  },
  'benefits.freeFeature': {
    en: 'Free Feature',
    ja: '無料機能',
    es: 'Función Gratuita',
    zh: '免费功能',
    fa: 'ویژگی رایگان'
  }
};
